export type TableColumn = {
  label: string;
  value: string;
  key: string;
  fixed?: boolean;
} & (
  | {
      type: TableColumnType.VALUE_WITH_PERCENTAGE;
      digits: number;
      internationalize: boolean;
    }
  | {
      type: TableColumnType.OBJECT;
      mappingFn: (object: any) => unknown;
    }
  | {
      type: TableColumnType.ACTIONS;
      actions: TableColumnAction[];
    }
  | {
      type: TableColumnType.DECIMAL;
      digits: number;
      internationalize?: boolean;
    }
  | { type: TableColumnType.NUMBER; internationalize: boolean }
  | {
      type: Exclude<
        TableColumnType,
        | TableColumnType.VALUE_WITH_PERCENTAGE
        | TableColumnType.OBJECT
        | TableColumnType.ACTIONS
        | TableColumnType.DECIMAL
        | TableColumnType.NUMBER
      >;
    }
);

export type TableColumnAction =
  | 'delete'
  | 'edit'
  | 'play_arrow'
  | 'download'
  | 'view'
  | 'generateReport';

export const READ_OPERATIONS: TableColumnAction[] = ['download', 'view'];
export const WRITE_OPERATIONS: TableColumnAction[] = [
  'edit',
  'delete',
  'play_arrow',
];

export enum TableColumnType {
  STRING,
  NUMBER,
  DECIMAL,
  BOOLEAN,
  ACTIONS,
  DATE,
  DATE_TIME,
  FILTERABLE,
  OBJECT,
  VALUE_WITH_CURRENCY,
  VALUE_WITH_PERCENTAGE,
  SELECTABLE,
}
